import '../created/styles.scss';
import l from '../../../../lang';
import TopDashboardSection from '../../../common/top-dashboard-section';
import Card from '../../../common/card';
import CardDescription from '../../../common/card-description';
import { Button } from '../../../common/button';
import { Routes } from '../../../../config/routes';
import { useHistory } from 'react-router-dom';
import { segmentPaymentLinkListBtnCreatePaymentLink } from '../../../../utils/analytics';
import CreatedOneTimePaymentLink from '../created/one-time';
import { canCreatePaymentLinks } from '../../../../store/payment-link/roles';
import { useSelector } from 'react-redux';

const OneTimePaymentLinkPage = () => {
  const history = useHistory();
  const { auth } = useSelector(state => state);
  const canCreate = canCreatePaymentLinks(auth?.roles);

  const onCreateOneTimePaymentLinkHandler = () => {
    segmentPaymentLinkListBtnCreatePaymentLink();
    history.push(Routes.CREATE_ONE_TIME_PAYMENT_LINK);
  };

  return (
    <div className="created_payment_links">
      <TopDashboardSection
        title={l('menu.subItem.ONE_TIME_PAYMENT_LINK')}
        subtitle={l('oneTimePaymentLink.page.subheadline')}
      />
      <Card>
        <CardDescription>{l('createdPaymentLink.subheadline')}</CardDescription>
        <div className="created_payment_links__create_btn">
          <Button fullWidth disabled={!canCreate} onClick={onCreateOneTimePaymentLinkHandler}>
            {l('createdPaymentLink.redirectBtn')}
          </Button>
        </div>
        <div className="created_payment_links__content">
          <CreatedOneTimePaymentLink />
        </div>
      </Card>
    </div>
  );
};

export default OneTimePaymentLinkPage;
